import { gql } from '@apollo/client';

export const postArrepentimientoIndexSP = gql`
mutation  ArrepentimientoIndexApiRQ{
    ArrepentimientoIndexApiRS(input: $input)  
        @rest(type: "ArrepentimientoIndexApiRS", path: "/api/gateway/formularios/Arrepentido", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`

